import { Node_Type } from "./../../../../ricos-schema/legacy/wix/rich_content/v1";
import BlockquoteRenderer from "./blockquote/blockquote";
import CodeBlockRenderer from "./codeblock/codeblock";
import HeadingRenderer from "./heading/heading";
import BulletedListRenderer from "./lists/bulletedList";
import ListItemRenderer from "./lists/listItem";
import OrderedListRenderer from "./lists/orderedList";
import ParagraphRenderer from "./paragraph/paragraph";
import TextRenderer from "./text/text";
const renderers = {
  [Node_Type.PARAGRAPH]: ParagraphRenderer,
  [Node_Type.TEXT]: TextRenderer,
  [Node_Type.BLOCKQUOTE]: BlockquoteRenderer,
  [Node_Type.CODE_BLOCK]: CodeBlockRenderer,
  [Node_Type.HEADING]: HeadingRenderer,
  [Node_Type.BULLETED_LIST]: BulletedListRenderer,
  [Node_Type.ORDERED_LIST]: OrderedListRenderer,
  [Node_Type.LIST_ITEM]: ListItemRenderer
};
var renderers_default = renderers;
export {
  renderers_default as default
};
//# sourceMappingURL=index.js.map
